import UserAvatar from "../../components/global/avtar/UserAvatar";

const columns = [
    {
        title: "User",
        dataIndex: "user",
        render: (_, record) => (
            <UserAvatar
                data={{
                    name: record?.name,
                    email: record?.email,
                    profileImage: record?.profilePicUrl,
                }}
            />
        ),
    },
  {
    title: "Ticket No",
    dataIndex: "ticketNo",
  },
  {
    title: "Query Type",
    dataIndex: "queryName",
  },
  {
    title: "Title",
    dataIndex: "title",
  },
  {
    title: "Contact Name",
    dataIndex: "name",
  },
  // {
  //   title: "User Type",
  //   dataIndex: "ticketUserType",
  // },
  
  {
    title: "Priority",
    dataIndex: "priority",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Actions",
    dataIndex: "actions",
  },
];

export default columns;
